const { shapes } = require('./shapes');

const imageNotAvailablePath = '/static/img/image-not-available.png';

const defaultBgRemoveFilter = {
  enabled: false,
  bgRemovedUrl: '',
  steps: []
};

const defaultBackgroundRemoveOptions = {
  model: 'u2net',
  alphaMatting: 'False',
  alphaMattingSettings: {
    foregroundThreshold: 240,
    backgroundThreshold: 10,
    erodeSize: 10
  },
  cropToVisiblePixels: 'False'
};

const clippingDefaults = {
  clipLayerId: "",
  clipLayerName: "",
  enabled: false,
  clipPath: shapes[0].path,
  scaleX: 1,
  scaleY: 1,
  originX: 'center',
  originY: 'center',
  rotateAngle: 0,
  clipPositionOffsets: {
    hOffset: 0,
    vOffset: 0
  }
}

const defaultInpaintForegroundFilter = {
  enabled: false,
  autoMask: true,
  maskUrl: '',
  expandMask: 30, // px
  fgRemovedUrl: ''
};

const imageFits = {
  original: 0,
  stretchToFit: 1,
  fillToBounds: 2,
  fitAndCrop: 3,
  crop: 4,
  clipToBounds: 5
}

const imageSourceTypes = {
  library: 'Library',
  unsplash: 'Unsplash',
  text2image: 'AI Image'
}

const galleryOptions = [
  imageSourceTypes.library,
  imageSourceTypes.unsplash,
  imageSourceTypes.text2image
]

const bgRemovalModelOptions = [
  { name: 'General', value: 'u2net' },
  { name: 'Lite', value: 'u2netp' },
  { name: 'Human', value: 'u2net_human_seg' },
  { name: 'Cloth', value: 'u2net_cloth_seg' },

  { name: 'Silueta', value: 'silueta' },

  { name: 'Birefnet General', value: 'birefnet-general' },
  { name: 'Birefnet General Lite', value: 'birefnet-general-lite' },
  { name: 'Birefnet Portrait', value: 'birefnet-portrait' },
  { name: 'Birefnet DIS', value: 'birefnet-dis' },
  { name: 'Birefnet HRSOD', value: 'birefnet-hrsod' },
  { name: 'Birefnet COD', value: 'birefnet-cod' },
  { name: 'Birefnet Massive', value: 'birefnet-massive' },

  { name: 'SAM', value: 'sam-onnx' },
  { name: 'Isnet General Use', value: 'isnet-general-use' }
]



module.exports = {
  imageNotAvailablePath,
  defaultBgRemoveFilter,
  defaultBackgroundRemoveOptions,
  clippingDefaults,
  defaultInpaintForegroundFilter,
  imageFits,
  imageSourceTypes,
  galleryOptions,
  bgRemovalModelOptions
};